/**
 * @deprecated This file is kept for backward compatibility.
 * Please use `@lib/utils` instead.
 *
 * This file re-exports all utilities from src/lib/utils.ts
 */
export * from "@lib/utils";
